/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

//MATERIAL
import {
  withStyles,
  createTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import cssStyles from "./edenredPaymentSettings.module.css";

import {
  getAllPayments as getPayments,
  updatePayment,
} from "../../../../reducers/paymentSlice";
import paymentsConstants from "../../../../constants/payments.constants";
import { Notification } from "../../../../containers/notification";
import { selectUser } from "../../../../reducers/userSlice";
import mongoose from "mongoose";
import {
  loadingOff,
  loadingOn,
  selectLoadingUI,
} from "../../../../reducers/uiSlice";
import { selectCompany, getCompany } from "../../../../reducers/companySlice";
import { useChangeRecord } from "../../../../utils/hooks/useChangeRecord";
import companyService from "../../../../utils/services/company";
import {
  selectChangesDeposit,
  setChanges,
} from "../../../../reducers/depositSlice";
import dateUtils from "../../../../utils/date";
import InputComponent from "../../../inputs";
import { useNavigate } from "react-router-dom";
import { selectSubsidiaries } from "../../../../reducers/subsidiarySlice";
import { Tab, Tabs } from "@material-ui/core";
import lumaUtils from "@lumarketo/luma-utils";
import config from "../../../../utils/config";
import paymentsService from "../../../../utils/services/payments";

const edenredLogo = "https://dgdvd9d8e5bk8.cloudfront.net/edenred.svg";

const defaultData = (company) => ({
  name: paymentsConstants.TYPES.Edenred,
  factor: 1,
  duration: 60,
  startTime: "01:00",
  endTime: "23:59",
  details: [],
  useSandbox: false,
  _id: new mongoose.Types.ObjectId().toHexString(),
  IdCompany: company._id,
  subsidiaryId: "",
});

function EdenredPaymentSettings() {
  const company = useSelector(selectCompany);
  const [apiKey, setApiKey] = useState("");
  const [clientId, setClientId] = useState("");
  const [paymentClientId, setPaymentClientId] = useState("");
  const [paymentClientSecret, setPaymentClientSecret] = useState("");
  const [mid, setMid] = useState("");
  const [tenant, setTenant] = useState("");
  const [redirectUri, setRedirectUri] = useState("");
  const [updated, setUpdated] = useState(false);
  const [payment, setPayment] = useState(null);
  const [useEdenred, setUseEdenred] = useState(false);
  const [showInputs, setShowInputs] = useState(false);
  const [payments, setPayments] = useState([]);
  const subsidiaries = useSelector(selectSubsidiaries);
  const { enqueueSnackbar } = useSnackbar();
  const changes = useSelector(selectChangesDeposit);
  const dispatch = useDispatch();
  const { recordChange } = useChangeRecord();
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const [subsidiaryId, setSubsidiaryId] = useState(subsidiaries[0]?._id ?? "");
  const isLoading = useSelector(selectLoadingUI);

  useEffect(() => {
    if (company?._id) setPayment(defaultData(company));
  }, [company?._id]);

  useEffect(() => {
    if (subsidiaries?.length > 0 && subsidiaries[0]?._id)
      setSubsidiaryId(subsidiaries[0]._id);
  }, [subsidiaries]);

  useEffect(() => {
    setUseEdenred(company?.UsePayments?.useEdenred ? true : false);
    if (company?.Payments) {
      const found = company.Payments.filter(
        (item) => item.name === paymentsConstants.TYPES.Edenred
      );
      if (found.length > 0) {
        setPayments(found);
        setUpdated(false);
      }
    }
  }, [company?.Payments, company.UsePayments]);

  useEffect(() => {
    function getData() {
      const { useSubsidiaryPayment } = company;
      const found = payments.find((item) =>
        !useSubsidiaryPayment
          ? item.name === paymentsConstants.TYPES.Edenred && !item.subsidiaryId
          : item.name === paymentsConstants.TYPES.Edenred &&
            item.subsidiaryId === subsidiaryId
      );
      if (found) setPayment(found);
      else setPayment(defaultData(company));
      setUpdated(false);
    }

    if (
      (subsidiaryId !== "" || !company.useSubsidiaryPayment) &&
      payments.length
    )
      getData();
  }, [subsidiaryId, company.useSubsidiaryPayment, payments.length]);

  useEffect(() => {
    let isMounted = true;

    const runDecryption = async () => {
      setUpdated(false);

      if (
        payment?.details?.length > 0 &&
        isMounted &&
        subsidiaryId &&
        subsidiaryId === payment?.subsidiaryId
      ) {
        const detail = payment?.details?.[0];
        try {
          dispatch(loadingOn());
          if (config?.secretKey && config?.secretIv && detail?.apiKey) {
            const decrypted = await lumaUtils.secretManagementUtils.deencript(
              detail.apiKey,
              config.secretKey,
              config.secretIv
            );
            setApiKey(decrypted || "");
          } else {
            setApiKey("");
          }
          setClientId(detail?.clientId || "");
          setPaymentClientId(detail?.paymentClientId || "");
          setPaymentClientSecret(detail?.paymentClientSecret || "");
          setMid(detail?.mid || "");
          setTenant(detail?.tenant || "");
          setRedirectUri(detail?.redirectUri || "");
        } catch (error) {
          console.error("Error decrypting Edenred key:", error);
          setApiKey("");
          setClientId("");
          setPaymentClientId("");
          setPaymentClientSecret("");
          setMid("");
          setTenant("");
          setRedirectUri("");
        } finally {
          dispatch(loadingOff());
        }
      } else {
        setApiKey("");
        setClientId("");
        setPaymentClientId("");
        setPaymentClientSecret("");
        setMid("");
        setTenant("");
        setRedirectUri("");
      }
    };

    runDecryption();
    return () => {
      isMounted = false;
    };
  }, [payment, subsidiaryId]);

  const handleCancel = () => {
    const detail = payment.details[0];
    setApiKey(detail.apiKey);
    setClientId(detail?.clientId || "");
    setPaymentClientId(detail?.paymentClientId || "");
    setPaymentClientSecret(detail?.paymentClientSecret || "");
    setMid(detail?.mid || "");
    setTenant(detail?.tenant || "");
    setRedirectUri(detail?.redirectUri || "");
    setUpdated(false);
  };

  const handleSave = async () => {
    try {
      dispatch(loadingOn());

      const encryptedApiKey = await lumaUtils.secretManagementUtils.encript(
        apiKey,
        config.secretKey,
        config.secretIv
      );

      if (encryptedApiKey) {
        const updatedPayment = {
          ...payment,
          IdCompany: company._id,
          subsidiaryId,
          details: [
            {
              ...payment.details[0],
              apiKey: encryptedApiKey,
              clientId,
              paymentClientId,
              paymentClientSecret,
              mid,
              tenant,
              redirectUri,
            },
          ],
        };

        await updatePayment(updatedPayment, user.token);
        await handleCompanySave();

        setPayment(updatedPayment);
        setUpdated(false);
        getPayments(company._id, user.token, dispatch);

        enqueueSnackbar(
          Notification({
            text: "Métodos de pago actualizados",
            variant: "success",
            withDetails: false,
          })
        );
      } else {
        enqueueSnackbar(
          Notification({
            text: "Métodos de pago no fueron actualizados",
            variant: "error",
            withDetails: false,
          })
        );
      }
    } catch (error) {
      console.error("Error saving Edenred credentials:", error);
      enqueueSnackbar(
        Notification({
          text: "Error al actualizar métodos de pago",
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      dispatch(loadingOff());
    }
  };

  const handleCompanySave = async () => {
    try {
      await companyService.updateCompany(
        company._id,
        {
          _id: company._id,
          UsePayments: {
            ...company.UsePayments,
            useEdenred,
          },
        },
        user.token
      );

      await getCompany(company._id, dispatch);
      enqueueSnackbar(
        Notification({
          text: "Datos de la tienda actualizados",
          variant: "success",
          withDetails: false,
        })
      );
      setUpdated(false);
      recordChange({
        module: "Métodos de pago",
        submodule: "Edenred",
        subsidiaryId,
        changes,
      });
    } catch (err) {
      enqueueSnackbar(
        Notification({
          text: "Error al actualizar datos de la tienda",
          variant: "error",
          withDetails: false,
        })
      );
    }
  };

  const updateChanges = (fieldName, newValue) => {
    const newChanges = [...changes];
    const change = {
      text: "",
      oldValue: null,
      newValue,
      date: dateUtils.getUTC().slice(0, 19).replace("T", " "),
    };

    if (fieldName === "useEdenred") {
      change.text = "Usar método de pago Edenred";
      change.oldValue = company.UsePayments[fieldName];
    }

    const index = newChanges.findIndex(
      (item) => item.text.toString() === change.text.toString()
    );

    if (index !== -1) {
      change.oldValue = newChanges[index].oldValue;
      newChanges[index] = change;
    } else {
      newChanges.push(change);
    }
    dispatch(setChanges(newChanges));
  };

  const handleDeleteCredential = async (id, token) => {
    dispatch(loadingOn());
    try {
      const deleted = await paymentsService.deletePaymentCredentials(id, token);
      if (deleted) {
        enqueueSnackbar(
          Notification({
            text: "Se ha eliminado la credencial de Edenred para la sucursal seleccionada",
            variant: "success",
            withDetails: false,
          })
        );
        setApiKey("");
        await getPayments(company._id, user.token, dispatch);
      }
    } catch (error) {
      console.error("Error deleting Edenred credentials:", error);
      enqueueSnackbar(
        Notification({
          text: "Error al tratar de eliminar credenciales de pago",
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      dispatch(loadingOff());
    }
  };

  return (
    <MuiThemeProvider theme={theme}>
      <div className={cssStyles.parentContainer}>
        <button
          className={cssStyles.backButton}
          onClick={() => navigate(-1)}
        >
          <span>
            <ArrowBackIcon />
          </span>
          Regresar
        </button>

        <div className={cssStyles.infoContainer}>
          <div className={cssStyles.titleLogoContainer}>
            <div className={cssStyles.containerLogo}>
              <img src={edenredLogo} alt="Edenred" height={40} />
            </div>
            <div className={cssStyles.serviceStatusContainer}>
              {!useEdenred ? (
                <div className={cssStyles.containerLogo}>
                  <img
                    src="https://s3.amazonaws.com/lumarketo.cl/clock-steps-home.svg"
                    alt=""
                  />
                  Inactivo
                </div>
              ) : (
                <div className={cssStyles.containerLogo}>
                  <img
                    src="https://s3.amazonaws.com/lumarketo.cl/check-steps-home.svg"
                    alt=""
                  />
                  Activo
                </div>
              )}
            </div>
          </div>

          <div className={cssStyles.infoItemContainer}>
            <p className={cssStyles.infoItemTitle}>
              Permite a tus clientes pagar con tarjetas de beneficios Edenred (Ticket Restaurant, Junaeb)
            </p>
          </div>

          <button
            className={cssStyles.buttonConfig}
            onClick={() => setShowInputs((p) => !p)}
          >
            Configurar
            <span>{!showInputs ? <ExpandMoreIcon /> : <ExpandLessIcon />}</span>
          </button>

          {showInputs && company.useSubsidiaryPayment && (
            <Tabs
              value={subsidiaryId}
              indicatorColor="primary"
              textColor="primary"
              onChange={(_, newValue) => setSubsidiaryId(newValue)}
              variant="scrollable"
              scrollButtons="auto"
            >
              {subsidiaries.map((item) => (
                <Tab label={item.Name} value={item._id} key={item._id} />
              ))}
            </Tabs>
          )}

          {showInputs && (
            <div className={cssStyles.configSettingsContainer}>
              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Client ID</label>
                <InputComponent
                  placeholder="OAuth Client ID"
                  type="text"
                  value={clientId}
                  handler={(e) => {
                    setClientId(e.target.value);
                    setUpdated(true);
                  }}
                />
              </div>

              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Client Secret</label>
                <InputComponent
                  placeholder="OAuth Client Secret"
                  type="text"
                  validation={apiKey === ""}
                  helperText={apiKey === "" ? "Ingresa tu Client Secret de Edenred" : ""}
                  value={apiKey}
                  handler={(e) => {
                    setApiKey(e.target.value);
                    setUpdated(true);
                  }}
                />
              </div>

              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Payment Client ID</label>
                <InputComponent
                  placeholder="Payment API Client ID"
                  type="text"
                  value={paymentClientId}
                  handler={(e) => {
                    setPaymentClientId(e.target.value);
                    setUpdated(true);
                  }}
                />
              </div>

              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Payment Client Secret</label>
                <InputComponent
                  placeholder="Payment API Client Secret"
                  type="text"
                  value={paymentClientSecret}
                  handler={(e) => {
                    setPaymentClientSecret(e.target.value);
                    setUpdated(true);
                  }}
                />
              </div>

              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Merchant ID (MID)</label>
                <InputComponent
                  placeholder="Merchant ID"
                  type="text"
                  value={mid}
                  handler={(e) => {
                    setMid(e.target.value);
                    setUpdated(true);
                  }}
                />
              </div>

              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Tenant</label>
                <InputComponent
                  placeholder="ej. cl-ben o cl-ben-junaeb"
                  type="text"
                  value={tenant}
                  handler={(e) => {
                    setTenant(e.target.value);
                    setUpdated(true);
                  }}
                />
              </div>

              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Redirect URI</label>
                <InputComponent
                  placeholder="OAuth callback URL"
                  type="text"
                  value={redirectUri}
                  handler={(e) => {
                    setRedirectUri(e.target.value);
                    setUpdated(true);
                  }}
                />
              </div>

              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>
                  Eliminar credenciales
                </label>
                <button
                  className={cssStyles.buttonDelete}
                  type="button"
                  onClick={() =>
                    handleDeleteCredential(payment?._id, user?.token)
                  }
                >
                  <DeleteOutlineIcon />
                </button>
              </div>

              <br />
              <div style={{ margin: "5px 0px", borderBottom: "1px solid gray" }} />
              <br />

              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Activar</label>
                <Checkbox
                  style={{ color: "#122526", margin: "0px 5px", padding: 0 }}
                  checked={useEdenred}
                  onChange={(e) => {
                    setUseEdenred(e.target.checked);
                    updateChanges("useEdenred", e.target.checked);
                    setUpdated(true);
                  }}
                  value={useEdenred.toString()}
                  color="primary"
                  id="useEdenred"
                />
              </div>
            </div>
          )}

          {showInputs && (
            <div className={cssStyles.buttonsContainer}>
              <button
                className={cssStyles.cancelButton}
                disabled={!updated || isLoading}
                onClick={handleCancel}
              >
                Cancelar
              </button>
              <button
                className={cssStyles.confirmButton}
                disabled={!updated || isLoading}
                onClick={handleSave}
              >
                Guardar
              </button>
            </div>
          )}
        </div>
      </div>
    </MuiThemeProvider>
  );
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
});

const theme = createTheme({
  typography: {
    useNextVariants: true,
    fontFamily: "Roboto, sans-serif !important",
  },
  palette: {
    primary: { main: "#122526" },
  },
  overrides: {
    MuiFormLabel: {
      root: { color: "#122526 !important" },
    },
    MuiInput: {
      underline: {
        "&:hover:not($disabled):before": {
          borderBottom: "2px solid #122526",
        },
        "&:after": { borderBottom: "2px solid #122526" },
      },
    },
    MuiFormControl: {
      root: { width: 100, margin: "0px 5px" },
    },
  },
});

export default withStyles(styles)(EdenredPaymentSettings);
